module.exports = __webpack_public_path__ + "static/media/orchidsLogo.f9a7744c.jpeg";